import React, { useState, useEffect } from "react";
import "./Addschool.scss";
import axios from "axios";
import { FaAnglesLeft } from "react-icons/fa6";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useNavigate } from "react-router-dom";
import { SManagement } from "../../ReusableComponents/CommonApis";
import { DSR } from "../../ReusableComponents/CommonApis";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { useSelector, useDispatch } from "react-redux";
// import { AlertOptionsData } from "../../Redux/Reducers/Common/Alerts";
import * as Yup from "yup";
import Loading from "../../Student/Reusablecomponents/Loading";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { Society, GetStationorCantonmentNames } from "../../ReusableComponents/NCLAdminDropdowns";
const AddSchool = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ErrorMessage, setErrors] = useState({});

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const UpdateSchool = useSelector(
    (state) => state.EditSchool.AddEditSchoolDetails
  );

  const [InstId, SetInstId] = useState();
    const [SelectINID, SetSelectINID] = useState(UpdateSchool?.systemID);
  // const [Logo, Setlogo] = useState();
  const [SRSData, SetSRSData] = useState(
    SelectINID == "2"
    ? UpdateSchool?.State || ""
    : UpdateSchool?.Region|| ""
  );
  const [Load, SetLoad] = useState(false);
  const [INAddres, SetINAddres] = useState();
  const [SData, SetSData] = useState(SelectINID == "2"
    ? UpdateSchool?.Region|| ""
    : UpdateSchool?.State|| "");
  const [DistData, SetDistData] = useState(UpdateSchool?.District || "");
  const [StationId, SetStationId] = useState(UpdateSchool?.stationId || "");



  const [Schldetails, SetSchldetails] = useState({
    UDISECode: UpdateSchool?.udiseCode || "",
    SchoolName: UpdateSchool?.schoolName || "",
    SchlManagement: UpdateSchool?.schoolManagement || "",
    Society: UpdateSchool?.societyID || "",
    boardofexam: UpdateSchool?.boardID || "",
    schlloc: UpdateSchool?.schoolType || "",
    city: UpdateSchool?.townCity || "",
    contactname: UpdateSchool?.contactName || "",
    contactnumber: UpdateSchool?.contactPhone || "",
    emailid: UpdateSchool?.eMail || "",
    address: UpdateSchool?.address1 || "",
    pincode: UpdateSchool?.pinCode || "",
    medofinstruction: UpdateSchool?.mediumID || "",
    RegionHierarchyId: SRSData || "",
    StateHierarchyId: SData || "",
    DistictHierarchyId: DistData || "",
    // Region: UpdateSchool?.Region || "",
    // State: UpdateSchool?.State || "",
    // District: UpdateSchool?.District || ""
  });

  const FIllDetails = (e, Name) => {
    SetSchldetails({ ...Schldetails, [e.target?.name || Name]: e });
  };

  const GetInstitutes = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(process.env.REACT_APP_API_BASE_URL + `/NCLAdmin/Institutes`, {
        headers: { XApiKey: process.env.REACT_APP_XApiKey },
      })
      .then((res) => {
        const Institutes = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.instituteName, {
                  display: item.instituteName,
                  value: item.instituteId,
                }),
              new Map()
            )
            .values()
        );
        // SetSelectINID(Institutes[0].value);
        SetInstId(Institutes);
        SetINAddres(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err); 
      });
  };
  useEffect(() => {
    GetInstitutes();
  }, []);

  const BackButton = () => {
    navigate(-1);
  };

  // const HandleInstituteChange = (e) => {
  //   SetSelectINID(e);
  //   // SetSRSData("");
  //   SetSRSData("0");
  //   SetSData("");
  //   SetDistData("");
  // };
  const HandleInstituteChange = (e) => {
    SetSelectINID(e);
    // SetSRSData("");
    if (e == "1" || e == "3" || e == "6") {
      SetSRSData("-");
    } else {
      SetSRSData("0");
    }
    SetSData("");
    SetDistData("");
  };
  const validationSchema = Yup.object().shape({
    UDISECode: Yup.string()
      .trim()
      .required("School U-DISE Code is required")
      .test(
        "len",
        "School U-DISE Code should be exactly 11 digits",
        (val) => !val || val.length === 11
      )
      .matches(/^\d{11}$/, {
        message: "School U-DISE Code must contain exactly 11 digits",
        excludeEmptyString: true,
      }),
    SchoolName: Yup.string()
      .trim()
      .required("School Name is required")
      .max(200, "School Name cannot exceed 200 characters")
      .matches(/^[A-Za-z\s]+$/, {
        message: "School Name must contain only alphabets",
        excludeEmptyString: true,
      }),
    SchlManagement: Yup.string().required("School Management is required"),
    System: Yup.string().required("System is required"),
    Region: Yup.string().when("System", {
      is: (System) => System === "1" || System === "3",
      then: () => Yup.string().required("Region is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    State: Yup.string().required("State is required"),
    District: Yup.string().required("District is required"),
    //  Society : Yup.string().required("Society is required"),
    Society: Yup.string().when("System", {
      is: (System) => System === "5" || System === "8" || System === "9",
      then: () => Yup.string().required("Society is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    Station: Yup.string().when("System", {
      is: (System) => System === "6",
      then: () => Yup.string().required("Station is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    boardofexam: Yup.string().required("Board is required"),
    schlloc: Yup.string().required("School Location is required"),
    city: Yup.string()
      .required("City is required")
      .matches(/^[A-Za-z\s]+$/, {
        message: "City must contain only alphabets",
        excludeEmptyString: true,
      }),
    contactname: Yup.string()
      .trim()
      .required("Contact Name is required")
      .max(50, "Contact Name cannot exceed 50 characters")
      .matches(/^[A-Za-z\s]+$/, {
        message: "Contact Name must contain only alphabets",
        excludeEmptyString: true,
      }),
    contactnumber: Yup.string()
      .trim()
      .required("Contact Number is required")
      .matches(/^\d{10}$/, {
        message: "Contact Number must be exactly 10 digits",
        excludeEmptyString: true,
      }),
    emailid: Yup.string()
      .required("Email Id is required")
      .email("Enter a valid Email Id"),
    address: Yup.string()
      .trim()
      .required("Address is required")
      .max(200, "Address cannot exceed 200 characters"),
    pincode: Yup.string()
      .required("PinCode is required")
      .matches(/^\d{6}$/, {
        message: "PinCode must be exactly 6 digits",
        excludeEmptyString: true,
      }),
    medofinstruction: Yup.string().required("Medium is required"),
  });

  const SubmitForm = () => {
    const SchoolDetails = {
      ...Schldetails,
      Region: SRSData,
      System: SelectINID?.toString(),
      State: SData,
      District: DistData,
    };
    validationSchema
      .validate(SchoolDetails, { abortEarly: false })
      .then(() => {
        SaveSchool(SchoolDetails);
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        setErrors(newErrors);
      });
  };
  const SaveSchool = async (SchoolDetails) => {
    // const formData = new FormData();
    // formData.append("logo",Logo);
    const AddSchoolDetails = {
      udiseCode: SchoolDetails.UDISECode,
      schoolName: SchoolDetails.SchoolName,
      schoolManagementId: SchoolDetails.SchlManagement,
      instituteId: SelectINID,
      societyId: SchoolDetails?.Society || "0",
      boardId: SchoolDetails.boardofexam,
      schooltypeId: SchoolDetails.schlloc,
      townCity: SchoolDetails.city,
      contactName: SchoolDetails.contactname,
      contactPhone: SchoolDetails.contactnumber,
      eMail: SchoolDetails.emailid,
      address: SchoolDetails.address,
      pinCode: SchoolDetails.pincode?.toString() || "0",
      mediumId: SchoolDetails.medofinstruction,
      // logo: Logo || "",
      createdBy: items.userId,
      // hierarchyvaluesListCSV:
      //   SRSData != 0
      //     ? `${SRSData},${SData},${DistData}`
      //     : `${SData},${DistData}`,
      hierarchyvaluesListCSV:
        SelectINID == "2"
          ? `${SData},${SRSData},${DistData}`
          : SRSData != 0
            ? `${SRSData},${SData},${DistData}`
            : `${SData},${DistData}`,

      userId: UpdateSchool?.userId,
      modifiedBy: items.userId,
      id: UpdateSchool?.id,
      RegionHierarchyId: SRSData,
      StateHierarchyId: SData,
      DistictHierarchyId: DistData,
      stationId: StationId || "0"
    };
    // const AddSchoolDetails ={AddSchoolDetail,formData}
    if (!UpdateSchool) {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/AddSchool",
          AddSchoolDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          navigate(-1);
          notify("School added successfully", "success");
        })
        // .catch((err) => {
        //   //console.log(err);
        //   setErrors({
        //     ...ErrorMessage,
        //     SchoolName: "School Name already exist",
        //     UDISECode: "UDISECode already exist",
        //   });
        .catch((err) => {
          const message = err?.response?.data;
          if (message === "School name already exists.") {
            setErrors({
              ...ErrorMessage,
              SchoolName: "School Name already exists",
              UDISECode: "",
            });
          } else if (message === "UDISE code already exists.") {
            setErrors({
              ...ErrorMessage,
              SchoolName: "",
              UDISECode: "UDISE Code already exists",
            });
          } else if (message === "School name and UDISE code already exists.") {
            setErrors({
              ...ErrorMessage,
              SchoolName: "School Name already exists",
              UDISECode: "UDISE Code already exists",
            });
          }
          else {
            notify("Unable to add school", "error");
          }
        });
    } else {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/EditSchool",
          AddSchoolDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          navigate(-1);
          notify("School Updated successfully", "success");
        })
        // .catch((err) => {
        //   console.log(err);
        // });
        .catch((err) => {
          const message = err?.response?.data;
          if (message === "School name already exists.") {
            setErrors({
              ...ErrorMessage,
              SchoolName: "School Name already exists",
              UDISECode: "",
            });
          } else if (message === "UDISE code already exists.") {
            setErrors({
              ...ErrorMessage,
              SchoolName: "",
              UDISECode: "UDISE Code already exists",
            });
          } else if (message === "School name and UDISE code already exists.") {
            setErrors({
              ...ErrorMessage,
              SchoolName: "School Name already exists",
              UDISECode: "UDISE Code already exists",
            });
          } else {
            notify("Unable to edit school", "error");
          }
        });

    }
  };
console.log("UpdateSchool",UpdateSchool)
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />

        <div className="MainHeading">
          {UpdateSchool ? "Edit" : "Add"} School
          <div
            className=" Buttons BackNavigation mb-3 dflex alignitems JCCenter gap-1 "
            style={{ float: "left" }}
            onClick={BackButton}
          >
            <FaAnglesLeft /> Back{" "}
          </div>
        </div>
        <div className="Card mt-3 w-100">
          <div className="School-Details-Form  mb-3">
            <div>
              <div className="DropdownHeader">
                School U-DISE Code <span>*</span>{" "}
              </div>
              <input
                className="NCLDropdown w-100"
                type="number"
                name="UDISECode"
                placeholder="Enter School U-DISE Code"
                defaultValue={Schldetails.UDISECode}
                onChange={(e) => FIllDetails(e.target.value, "UDISECode")}
              />
              {ErrorMessage.UDISECode && (
                <div className="error-message">{ErrorMessage.UDISECode}</div>
              )}
            </div>

            <div>
              <div className="DropdownHeader">
                School Name <span>*</span>
              </div>
              <input
                className="NCLDropdown w-100"
                type="text"
                name="SchoolName"
                placeholder="Enter School Name"
                defaultValue={Schldetails.SchoolName}
                onChange={(e) => FIllDetails(e.target.value, "SchoolName")}
              />
              {ErrorMessage.SchoolName && (
                <div className="error-message">{ErrorMessage.SchoolName}</div>
              )}
            </div>

            <div>
              <SManagement
                className="NCLDropdown w-100"
                LovId={47}
                name="SchlManagement"
                SOption={Schldetails.SchlManagement}
                onChange={(e) => FIllDetails(e, "SchlManagement")}
                Displayname="Select"
                labelname={
                  <div className="DropdownHeader">
                    School Management <span>*</span>{" "}
                  </div>
                }
              />
              {ErrorMessage.SchlManagement && (
                <div className="error-message">
                  {ErrorMessage.SchlManagement}
                </div>
              )}
            </div>

            <div>
              {InstId && (
                <DropdownValues
                  className={`w-100 ${UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                    }`}
                  options={InstId}
                  name="System"
                  Displayname="Select"
                  // onChange={(e) => { SetSelectINID(e.target.value) }}
                  onChange={(e) => {
                    HandleInstituteChange(e.target.value);
                  }}
                  selectoption={SelectINID}
                  disabled={UpdateSchool}
                  labelname={
                    <div className="DropdownHeader">
                      Institute <span>*</span>{" "}
                    </div>
                  }
                />
              )}
              {ErrorMessage.System && (
                <div className="error-message">{ErrorMessage.System}</div>
              )}
            </div>
            {(SelectINID == "1" || SelectINID == "3" || SelectINID == "6") && (
              <div>
                {" "}
                <DSR
                  className={`w-100 ${UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                    }`}
                  PId={SelectINID}
                  SID="0"
                  RID="0"
                  /*StoreValue={SetSRSData}*/ name="Region"
                  Displayname="Select"
                  onChange={(e) => {
                    SetSRSData(e?.toString() || "-");
                  }}
                  SOption={SRSData}
                  disable={UpdateSchool}
                  labelname={
                    <div className="DropdownHeader">
                      Region <span>*</span>{" "}
                    </div>
                  }
                />
                {ErrorMessage.Region && (
                  <div className="error-message">{ErrorMessage.Region}</div>
                )}
              </div>
            )}
            {SelectINID == "2" && (
              <>
                {/* State */}
                <div>
                  <DSR
                    className={`w-100 ${UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                      }`}
                    PId={SelectINID}
                    SID="0"
                    RID="0"
                    name="State"
                    Displayname="Select"
                    onChange={(e) => {
                      SetSData(e);
                      SetSRSData("");
                      SetDistData("");
                    }}
                    SOption={SData}
                    disable={UpdateSchool}
                    labelname={
                      <div className="DropdownHeader">
                        State <span>*</span>
                      </div>
                    }
                  />

                  {ErrorMessage.State && (
                    <div className="error-message">{ErrorMessage.State}</div>
                  )}
                </div>

                {/* Region - State ID passed here */}
                <div>
                  <DSR
                    className={`w-100 ${UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                      }`}
                    PId={SelectINID}
                    SID={SData || 0}
                    RID="0"
                    name="Region"
                    Displayname="Select"
                    onChange={(e) => {
                      SetSRSData(e?.toString() || "-");
                      SetDistData("");
                    }}
                    SOption={SRSData}
                    disable={UpdateSchool || !SData}
                    labelname={
                      <div className="DropdownHeader">
                        Region <span>*</span>
                      </div>
                    }
                  />

                  {ErrorMessage.Region && (
                    <div className="error-message">{ErrorMessage.Region}</div>
                  )}
                </div>

                {/* District - Region ID passed here */}
                <div>
                  <DSR
                    className="w-100 NCLDropdown"
                    PId={SelectINID}
                    SID={SData || 0}
                    RID={SRSData || 0}
                    name="District"
                    Displayname="Select"
                    onChange={(e) => {
                      SetDistData(e);
                    }}
                    SOption={DistData}
                    disable={!SRSData}
                    labelname={
                      <div className="DropdownHeader">
                        District <span>*</span>
                      </div>
                    }
                  />

                  {ErrorMessage.District && (
                    <div className="error-message">{ErrorMessage.District}</div>
                  )}
                </div>
              </>
            )}
            {SelectINID != "1" && SelectINID != "2" && SelectINID != "3" && SelectINID != "6" && (
              <>
                <div>
                  <DSR
                    className={`w-100 ${UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                      }`}
                    PId={SelectINID}
                    // SID={
                    //   SelectINID == "1" || SelectINID == "3"
                    //     ? parseInt(SRSData)
                    //     : "0"
                    // }
                    SID="0"
                    RID={SRSData || 0}
                /* id={SRSData!=="0" ? SRSData  : 0} StoreValue={SetSData}*/ name="State"
                    Displayname="Select"
                    onChange={(e) => SetSData(e)}
                    SOption={SData}
                    disable={UpdateSchool}
                    labelname={
                      <div className="DropdownHeader">
                        State <span>*</span>{" "}
                      </div>
                    }
                  />
                  {ErrorMessage.State && (
                    <div className="error-message">{ErrorMessage.State}</div>
                  )}
                </div>

                <div>
                  <DSR
                    // className={`w-100 ${UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                    //   }`}
                    className={`w-100 NCLDropdown`}
                    PId={SelectINID}
                    SID={SData}
                    RID={SRSData || 0}
                /*StoreValue={SetDistData}*/ name="District"
                    Displayname="Select"
                    onChange={(e) => {
                      SetDistData(e);
                    }}
                    SOption={DistData}
                    // disable={UpdateSchool}
                    labelname={
                      <div className="DropdownHeader">
                        District <span>*</span>
                      </div>
                    }
                  />
                  {ErrorMessage.District && (
                    <div className="error-message">{ErrorMessage.District}</div>
                  )}
                </div>
              </>)}

            {/* <SManagement 
                className={`w-100 ${
                  UpdateSchool ? "DisabledNCLDropdown" : "NCLDropdown"
                }`}
                LovId={59}
                name="Society"
                defaultValue={Schldetails.Society}
                onChange={(e) => FIllDetails(e, "Society")}
                Displayname="Select"
                SOption={Schldetails?.Society}
                disable={UpdateSchool}
                labelname={
                  <div className="DropdownHeader ">
                    Society<span>*</span>
                  </div>
                }
              /> */}
            {(parseInt(SelectINID) === 8 || parseInt(SelectINID) === 9 || parseInt(SelectINID) === 5) && <div>
              <Society
                className="NCLDropdown w-100"
                PId={SelectINID}
                id="0" Displayname="Select"
                // StoreValue={SetSocietyId}
                // disable={UpdateSchool}
                SOption={Schldetails?.Society}
                onChange={(e) => FIllDetails(e.value, "Society")}
                labelname={
                  <div className="DropdownHeader ">
                    Society<span>*</span>
                  </div>
                }
              />
              {ErrorMessage.Society && (
                <div className="error-message">{ErrorMessage.Society}</div>
              )}</div>}

            {parseInt(SelectINID) === 6 && <div>
              <GetStationorCantonmentNames
                className="NCLDropdown w-100"
                SOption={StationId}
                Displayname="Select"
                //SOption={StationId}
                onChange={(e) => {
                  SetStationId(e);
                }}
                StoreValue={(value) => {
                  FIllDetails(value, "Station");
                }}
                labelname={
                  <div className="DropdownHeader">
                    Station / Cantonment <span>*</span>
                  </div>
                }
              />
              {ErrorMessage.Station && (
                <div className="error-message">{ErrorMessage.Station}</div>
              )}</div>}

            <div>
              <SManagement
                className="NCLDropdown w-100"
                LovId={57}
                name="boardofexam"
                onChange={(e) => FIllDetails(e, "boardofexam")}
                SOption={Schldetails?.boardofexam}
                Displayname="Select"
                labelname={
                  <div className="DropdownHeader ">
                    Board Of Examination/Affiliation <span>*</span>
                  </div>
                }
              />
              {ErrorMessage.boardofexam && (
                <div className="error-message">{ErrorMessage.boardofexam}</div>
              )}
            </div>
            <div>
              <SManagement
                className="NCLDropdown w-100"
                LovId={46}
                name="schlloc"
                defaultValue={Schldetails.schlloc}
                onChange={(e) => FIllDetails(e, "schlloc")}
                Displayname="Select"
                SOption={Schldetails?.schlloc}
                labelname={
                  <div className="DropdownHeader">
                    School Location<span>*</span>{" "}
                  </div>
                }
              />
              {ErrorMessage.schlloc && (
                <div className="error-message">{ErrorMessage.schlloc}</div>
              )}
            </div>
            <div>
              <div className="DropdownHeader">
                City <span>*</span>{" "}
              </div>
              <input
                className="NCLDropdown w-100"
                type="text"
                name="city"
                defaultValue={Schldetails.city}
                onChange={(e) => FIllDetails(e.target.value, "city")}
                placeholder="Enter City Name"
              />
              {ErrorMessage.city && (
                <div className="error-message">{ErrorMessage.city}</div>
              )}
            </div>
            <div>
              <div className="DropdownHeader">
                Contact Name <span>*</span>{" "}
              </div>
              <input
                className="NCLDropdown w-100"
                type="text"
                name="contactname"
                defaultValue={Schldetails.contactname}
                onChange={(e) => FIllDetails(e.target.value, "contactname")}
                placeholder="Enter Contact Name "
              />
              {ErrorMessage.contactname && (
                <div className="error-message">{ErrorMessage.contactname}</div>
              )}
            </div>
            <div>
              <div className="DropdownHeader">
                Contact Number <span>*</span>{" "}
              </div>
              <input
                className="NCLDropdown w-100"
                type="number"
                name="contactnumber"
                defaultValue={Schldetails.contactnumber}
                onChange={(e) => FIllDetails(e.target.value, "contactnumber")}
                placeholder="Enter Contact Number "
              />
              {ErrorMessage.contactnumber && (
                <div className="error-message">
                  {ErrorMessage.contactnumber}
                </div>
              )}
            </div>
            <div>
              <div className="DropdownHeader">
                Email Id <span>*</span>{" "}
              </div>
              <input
                className="NCLDropdown w-100"
                type="text"
                name="emailid"
                defaultValue={Schldetails.emailid}
                onChange={(e) => FIllDetails(e.target.value, "emailid")}
                placeholder="Enter Email Id "
              />
              {ErrorMessage.emailid && (
                <div className="error-message">{ErrorMessage.emailid}</div>
              )}
            </div>
            <div>
              <div className="DropdownHeader ">
                Address <span>*</span>
              </div>
              <input
                className="NCLDropdown w-100"
                type="text"
                name="address"
                defaultValue={Schldetails.address}
                onChange={(e) => FIllDetails(e.target.value, "address")}
                placeholder="Enter Address "
              />
              {ErrorMessage.address && (
                <div className="error-message">{ErrorMessage.address}</div>
              )}
            </div>
            <div>
              <div className="DropdownHeader">
                PinCode <span>*</span>{" "}
              </div>
              <input
                className="NCLDropdown w-100"
                type="number"
                name="pincode"
                defaultValue={Schldetails?.pincode}
                onChange={(e) => FIllDetails(e.target.value, "pincode")}
                placeholder="Enter PinCode "
              />
              {ErrorMessage.pincode && (
                <div className="error-message">{ErrorMessage.pincode}</div>
              )}
            </div>
            <div>
              <SManagement
                className="NCLDropdown w-100"
                LovId={58}
                name="medofinstruction"
                defaultValue={Schldetails.medofinstruction}
                onChange={(e) => FIllDetails(e, "medofinstruction")}
                SOption={Schldetails?.medofinstruction}
                Displayname="Select"
                labelname={
                  <div className="DropdownHeader">
                    Medium of Instruction<span>*</span>{" "}
                  </div>
                }
              />
              {ErrorMessage.medofinstruction && (
                <div className="error-message">
                  {ErrorMessage.medofinstruction}
                </div>
              )}
            </div>
            {/* <div>
              <div className="DropdownHeader">Logo : </div>
              <input
                className="NCLDropdown w-100"
                type="file"
                accept=".png,.jpeg,.jpg"
                name="logo"
                onChange={(e) => Setlogo(e.target.files[0].name)}
              />
            </div> */}
            <div></div>
          </div>
          <div className="AddStudent-Buttons dflex">
            <button className="Buttons" onClick={SubmitForm} disabled={Load}>
              {UpdateSchool ? "Update" : "Save"}
            </button>
            <button className="Buttons" onClick={BackButton}>
              Cancel
            </button>
          </div>
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};

export default AddSchool; 